import styled from "styled-components/macro";

export const StyledRecommendationContainer = styled.div`
	background: #ffffff;
	width: ${(props) => (props.theme === "full" ? "100%" : "calc(100% - 54px)")};
	margin: ${(props) => (props.theme === "full" ? "4rem 0 0 0" : "0 auto")};
	height: 220px;
	border-radius: 4px;
	padding: ${(props) => (props.theme === "full" ? "2rem" : "1.5rem")};
	display: flex;
	flex-direction: column;
	position: relative;
`;

export const StyledMarkContainer = styled.div`
	position: absolute;
	width: 38px;
	height: 38px;
	left: ${(props) => (props.theme === "full" ? "15px" : "10px")};
	top: -19px;
	background: #ffffff;
	border-radius: 50%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding-top: 6px;
`;

export const StyledRecommender = styled.div`
	display: flex;
	gap: 0.6rem;
	align-items: center;
	text-align: left;
	margin-top: auto;
	justify-content: ${(props) => (props.theme === "full" ? "flex-end" : "initial")};
	h4 {
		font-weight: bold;
		font-size: 0.9rem;
		line-height: 1.4rem;
		color: #272b2f;
	}
	p {
		font-weight: normal;
		font-size: 0.8rem;
		line-height: 1.3rem;
		color: #272b2f;
		opacity: 0.5;
	}
`;

export const StyledRecommendation = styled.div`
	font-weight: 400;
	font-size: 1rem;
	font-style: italic;
	line-height: 1.6rem;
	text-align: left;
`;
